
import React from 'react';
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface CalculatorHeaderProps {
  installationType: 'home' | 'company';
  onInstallationTypeChange: (value: 'home' | 'company') => void;
  rooms: string;
  onRoomsChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CalculatorHeader: React.FC<CalculatorHeaderProps> = ({
  installationType,
  onInstallationTypeChange,
  rooms,
  onRoomsChange
}) => {
  return (
    <div className="space-y-6">
      <h2 className="text-xl md:text-2xl font-semibold">Oblicz koszt klimatyzacji</h2>
      
      {/* Installation Type Selection */}
      <div className="space-y-3">
        <label className="block text-sm font-medium text-gray-700">
          Rodzaj instalacji
        </label>
        <RadioGroup 
          value={installationType} 
          onValueChange={(value) => onInstallationTypeChange(value as 'home' | 'company')}
          className="flex gap-6"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="home" id="home" />
            <Label htmlFor="home">Dom / Mieszkanie</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="company" id="company" />
            <Label htmlFor="company">Firma / Biuro</Label>
          </div>
        </RadioGroup>
      </div>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Liczba pokoi do klimatyzacji
        </label>
        <input
          type="text"
          value={rooms}
          onChange={onRoomsChange}
          placeholder="Np. 3"
          className="input-field"
        />
      </div>
    </div>
  );
};

export default CalculatorHeader;
